import type { CsvVariantGroupingStrategy } from '@entities/platform-entities/integration/csv-variant-grouping-strategy.type';

export const CSV_VARIANT_GROUPING_OPTIONS: {
  label: string;
  value: CsvVariantGroupingStrategy;
}[] = [
  { label: 'Product URL (link)', value: 'externalUrl' },
  { label: 'Title', value: 'title' },
  { label: 'Description', value: 'description' },
  { label: 'Custom field', value: 'customField' },
];
